import { Box } from '@mui/material';
import { HlsTimelineBufferRowsTable } from './HlsTimelineBufferRowsTable';
import { HlsTimelinePlaylistRowsTable } from './HlsTimelinePlaylistRowsTable';
import { HlsTimelineStats } from './hls-timeline-stats-types';

type HlsTimelineStatsTableProps = {
  stats: HlsTimelineStats;
};

/** Debug table shown below the HLS timeline chart with buffer and playlist row metrics. */
export function HlsTimelineStatsTable({ stats }: HlsTimelineStatsTableProps) {
  return (
    <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
      <HlsTimelineBufferRowsTable
        rows={stats.bufferRows}
        currentTime={stats.currentTime}
        maxBufferLength={stats.maxBufferLength}
        forwardBufferInfo={stats.forwardBufferInfo}
      />
      <HlsTimelinePlaylistRowsTable rows={stats.playlistRows} />
    </Box>
  );
}
